(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["assistencia-tecnica"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const revealItems = [...root.querySelectorAll('[data-assist-reveal]')];

      if (!reducedMotion && 'IntersectionObserver' in window) {
        root.classList.add('has-motion');
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: .12, rootMargin: '0px 0px -40px' });
        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }

      const track = root.querySelector('[data-review-track]');
      if (!track || track.dataset.ready === 'true') return;
      track.dataset.ready = 'true';
      const cards = [...track.querySelectorAll('[data-review-card]')];
      const previous = root.querySelector('[data-review-prev]');
      const next = root.querySelector('[data-review-next]');
      const dots = root.querySelector('[data-review-dots]');
      if (!cards.length || !previous || !next || !dots) return;

      const distance = () => Math.max(1, cards[0].getBoundingClientRect().width + 16);
      const activeIndex = () => Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / distance())));
      const goTo = (index, behavior = 'smooth') => {
        track.scrollTo({ left: Math.max(0, Math.min(cards.length - 1, index)) * distance(), behavior });
      };

      cards.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Ir para avaliação ${index + 1}`);
        dot.addEventListener('click', () => goTo(index));
        dots.appendChild(dot);
      });

      const update = () => {
        const index = activeIndex();
        [...dots.children].forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
        previous.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };

      let autoplayTimer;
      const stopAutoplay = () => {
        window.clearInterval(autoplayTimer);
        autoplayTimer = undefined;
      };
      const startAutoplay = () => {
        if (reducedMotion || autoplayTimer || document.hidden) return;
        autoplayTimer = window.setInterval(() => {
          const nextIndex = activeIndex() >= cards.length - 1 ? 0 : activeIndex() + 1;
          goTo(nextIndex);
        }, 5200);
      };

      previous.addEventListener('click', () => goTo(activeIndex() - 1));
      next.addEventListener('click', () => goTo(activeIndex() + 1));
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      track.addEventListener('mouseenter', stopAutoplay);
      track.addEventListener('mouseleave', startAutoplay);
      track.addEventListener('focusin', stopAutoplay);
      track.addEventListener('focusout', startAutoplay);
      track.addEventListener('pointerdown', stopAutoplay, { passive: true });
      track.addEventListener('pointerup', startAutoplay, { passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? stopAutoplay() : startAutoplay());
      window.addEventListener('resize', update, { passive: true });
      update();
      startAutoplay();
    };

    document.querySelectorAll('[data-assistance-section]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-assistance-section]') ? event.target : event.target.querySelector('[data-assistance-section]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    if (window.InfoStoreCartInitialized) return;
    window.InfoStoreCartInitialized = true;

    let cartRequestActive = false;
    let shippingRequestId = 0;

    const storefrontRoot = () => window.Shopify?.routes?.root || '/';
    const delay = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

    const setCartFeedback = (message, isError = false) => {
      const feedback = document.querySelector('[data-cart-feedback]');
      if (!feedback) return;
      feedback.textContent = message;
      feedback.classList.toggle('is-error', isError);
    };

    const updateHeaderCount = (itemCount) => {
      document.querySelectorAll('.info-header__cart').forEach((cartLink) => {
        let badge = cartLink.querySelector('.info-header__cart-count');
        if (itemCount < 1) {
          badge?.remove();
          return;
        }
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'info-header__cart-count';
          cartLink.appendChild(badge);
        }
        badge.textContent = String(itemCount);
      });
    };

    const replaceCartSection = (html) => {
      if (!html) return false;
      const template = document.createElement('template');
      template.innerHTML = html.trim();
      const replacement = template.content.querySelector('[data-cart-section]');
      const current = document.querySelector('[data-cart-section]');
      if (!replacement || !current) return false;
      current.replaceWith(replacement);
      return true;
    };

    const lineMaximum = (line) => {
      if (!line || line.dataset.cartMax === undefined) return null;
      const maximum = Number.parseInt(line.dataset.cartMax, 10);
      return Number.isFinite(maximum) ? Math.max(0, maximum) : null;
    };

    const stockLimitMessage = (section, maximum) => (
      section?.dataset.cartStockLimitMessage?.replace('[quantity]', String(maximum)) || ''
    );

    const refreshCartSection = async (sectionId) => {
      const root = storefrontRoot();
      const [cartResponse, sectionResponse] = await Promise.all([
        fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }),
        fetch(`${root}cart?section_id=${encodeURIComponent(sectionId)}`, { credentials: 'same-origin' })
      ]);
      if (!cartResponse.ok || !sectionResponse.ok) throw new Error('Cart refresh failed');
      const [cart, sectionHtml] = await Promise.all([cartResponse.json(), sectionResponse.text()]);
      if (!replaceCartSection(sectionHtml)) throw new Error('Cart section rendering failed');
      updateHeaderCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('shopify:cart:updated', {
        bubbles: true,
        detail: { cart }
      }));
      restoreShippingEstimate();
      return cart;
    };

    const rememberPostalCode = (postalCode) => {
      try {
        window.sessionStorage.setItem('infostore_shipping_postal', postalCode);
      } catch (error) {
        console.warn('Não foi possível memorizar o CEP nesta sessão.', error);
      }
    };

    const savedPostalCode = () => {
      try {
        return window.sessionStorage.getItem('infostore_shipping_postal') || '';
      } catch (error) {
        return '';
      }
    };

    const formatPostalCode = (value) => {
      const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
      return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
    };

    const formatMoney = (value, currency) => {
      const numericValue = Number(value);
      if (!Number.isFinite(numericValue)) return String(value || '');
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: currency || 'BRL'
      }).format(numericValue);
    };

    const responseError = async (response) => {
      const payload = await response.clone().json().catch(() => null);
      return payload?.description || payload?.message || '';
    };

    const lookupPostalAddress = async (postalCode, calculator) => {
      const response = await fetch(`https://viacep.com.br/ws/${postalCode}/json/`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error(calculator.dataset.errorMessage);
      const address = await response.json();
      if (address.erro || !address.uf || !address.localidade) {
        throw new Error(calculator.dataset.invalidPostalMessage);
      }
      return address;
    };

    const requestShippingRates = async (postalCode, calculator) => {
      const address = await lookupPostalAddress(postalCode, calculator);
      const params = new URLSearchParams({
        'shipping_address[zip]': postalCode,
        'shipping_address[country]': 'Brazil',
        'shipping_address[province]': address.uf,
        'shipping_address[city]': address.localidade
      });
      const query = params.toString();
      const prepareResponse = await fetch(`${storefrontRoot()}cart/prepare_shipping_rates.json?${query}`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!prepareResponse.ok) throw new Error(await responseError(prepareResponse));

      const currentRequestId = ++shippingRequestId;
      for (let attempt = 0; attempt < 12; attempt += 1) {
        if (currentRequestId !== shippingRequestId) return null;
        if (attempt > 0) await delay(700);
        const ratesResponse = await fetch(`${storefrontRoot()}cart/async_shipping_rates.json?${query}`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!ratesResponse.ok) throw new Error(await responseError(ratesResponse));
        const payload = await ratesResponse.json();
        if (payload && Array.isArray(payload.shipping_rates)) return payload.shipping_rates;
      }
      throw new Error(calculator.dataset.errorMessage);
    };

    const calculateShipping = async (postalValue) => {
      const calculator = document.querySelector('[data-shipping-calculator]');
      if (!calculator) return;
      const input = calculator.querySelector('[data-shipping-postal]');
      const submit = calculator.querySelector('[data-shipping-submit]');
      const status = calculator.querySelector('[data-shipping-status]');
      const ratesList = calculator.querySelector('[data-shipping-rates]');
      const note = calculator.querySelector('[data-shipping-note]');
      const summary = document.querySelector('[data-shipping-summary]');
      const postalCode = String(postalValue || '').replace(/\D/g, '');

      input.value = formatPostalCode(postalCode);
      status.classList.remove('is-error', 'is-success');
      ratesList.replaceChildren();
      ratesList.hidden = true;
      note.hidden = true;

      if (postalCode.length !== 8) {
        status.textContent = calculator.dataset.invalidPostalMessage;
        status.classList.add('is-error');
        input.setAttribute('aria-invalid', 'true');
        return;
      }

      input.removeAttribute('aria-invalid');
      submit.disabled = true;
      status.textContent = calculator.dataset.calculatingMessage;
      rememberPostalCode(postalCode);

      try {
        const rates = await requestShippingRates(postalCode, calculator);
        if (!rates) return;
        if (rates.length === 0) {
          status.textContent = calculator.dataset.noRatesMessage;
          status.classList.add('is-error');
          if (summary) summary.textContent = calculator.dataset.noRatesMessage;
          return;
        }

        const currency = document.querySelector('[data-cart-section]')?.dataset.cartCurrency || 'BRL';
        rates.forEach((rate) => {
          const item = document.createElement('li');
          const name = document.createElement('span');
          const price = document.createElement('strong');
          name.textContent = rate.name;
          price.textContent = formatMoney(rate.price, rate.currency || currency);
          item.append(name, price);
          ratesList.appendChild(item);
        });

        const lowestRate = [...rates].sort((first, second) => Number(first.price) - Number(second.price))[0];
        status.textContent = calculator.dataset.successMessage;
        status.classList.add('is-success');
        ratesList.hidden = false;
        note.hidden = false;
        if (summary && lowestRate) {
          summary.textContent = `${calculator.dataset.summaryPrefix} ${formatMoney(lowestRate.price, lowestRate.currency || currency)}`;
        }
      } catch (error) {
        console.error('Erro ao calcular frete:', error);
        status.textContent = calculator.dataset.errorMessage;
        status.classList.add('is-error');
        if (summary) summary.textContent = calculator.dataset.errorMessage;
      } finally {
        submit.disabled = false;
      }
    };

    const restoreShippingEstimate = () => {
      const postalCode = savedPostalCode();
      if (!postalCode || !document.querySelector('[data-shipping-calculator]')) return;
      const input = document.querySelector('[data-shipping-postal]');
      if (input) input.value = formatPostalCode(postalCode);
      calculateShipping(postalCode);
    };

    const updateLine = async (line, quantity, input, previousQuantity) => {
      if (cartRequestActive || !line?.dataset.cartKey) return;
      const section = document.querySelector('[data-cart-section]');
      if (!section) return;
      const sectionId = section.dataset.cartSectionId;
      cartRequestActive = true;
      section.classList.add('is-updating');
      section.setAttribute('aria-busy', 'true');
      setCartFeedback(section.dataset.cartUpdatingMessage);

      try {
        const response = await fetch(`${storefrontRoot()}cart/change.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: line.dataset.cartKey,
            quantity,
            sections: [sectionId],
            sections_url: window.location.pathname
          })
        });
        const cart = await response.json();
        if (!response.ok) {
          const requestError = new Error(cart.description || cart.message || 'Cart update failed');
          requestError.status = response.status;
          throw requestError;
        }
        if (!replaceCartSection(cart.sections?.[sectionId])) throw new Error('Cart section rendering failed');
        updateHeaderCount(cart.item_count);
        setCartFeedback(document.querySelector('[data-cart-section]')?.dataset.cartUpdatedMessage || '');
        document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', {
          bubbles: true,
          detail: { cart }
        }));
        document.dispatchEvent(new CustomEvent('shopify:cart:updated', {
          bubbles: true,
          detail: { cart }
        }));
        restoreShippingEstimate();
      } catch (error) {
        console.error('Erro ao atualizar o carrinho:', error);
        try {
          await refreshCartSection(sectionId);
        } catch (refreshError) {
          console.error('Erro ao reconciliar o carrinho:', refreshError);
          if (input) input.value = String(previousQuantity);
        }
        const refreshedSection = document.querySelector('[data-cart-section]');
        const message = error.status === 422
          ? refreshedSection?.dataset.cartStockErrorMessage
          : refreshedSection?.dataset.cartErrorMessage;
        setCartFeedback(message || section.dataset.cartErrorMessage, true);
      } finally {
        cartRequestActive = false;
        document.querySelector('[data-cart-section]')?.classList.remove('is-updating');
        document.querySelector('[data-cart-section]')?.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-cart-minus], [data-cart-plus]');
      if (quantityButton) {
        event.preventDefault();
        if (cartRequestActive) return;
        const line = quantityButton.closest('[data-cart-line]');
        const input = line?.querySelector('[data-cart-input]');
        if (!line || !input) return;
        const previousQuantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        const maximum = lineMaximum(line);
        if (quantityButton.matches('[data-cart-plus]') && maximum !== null && previousQuantity >= maximum) {
          input.value = String(maximum);
          quantityButton.disabled = true;
          setCartFeedback(stockLimitMessage(document.querySelector('[data-cart-section]'), maximum), true);
          return;
        }
        const quantity = quantityButton.matches('[data-cart-minus]')
          ? Math.max(0, previousQuantity - 1)
          : Math.min(previousQuantity + 1, maximum ?? previousQuantity + 1);
        input.value = String(quantity);
        updateLine(line, quantity, input, previousQuantity);
        return;
      }

      const removeLink = event.target.closest('[data-cart-remove]');
      if (removeLink) {
        event.preventDefault();
        if (cartRequestActive) return;
        const line = removeLink.closest('[data-cart-line]');
        const input = line?.querySelector('[data-cart-input]');
        updateLine(line, 0, input, Number.parseInt(input?.value, 10) || 1);
      }
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-input]');
      if (!input || cartRequestActive) return;
      const line = input.closest('[data-cart-line]');
      const previousQuantity = Number.parseInt(input.defaultValue, 10) || 0;
      const requestedQuantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
      const maximum = lineMaximum(line);
      const quantity = maximum === null ? requestedQuantity : Math.min(requestedQuantity, maximum);
      input.value = String(quantity);
      if (maximum !== null && requestedQuantity > maximum) {
        setCartFeedback(stockLimitMessage(document.querySelector('[data-cart-section]'), maximum), true);
      }
      if (quantity !== previousQuantity) updateLine(line, quantity, input, previousQuantity);
    });

    document.addEventListener('input', (event) => {
      const cartInput = event.target.closest('[data-cart-input]');
      if (cartInput) {
        if (cartInput.value === '') return;
        const line = cartInput.closest('[data-cart-line]');
        const maximum = lineMaximum(line);
        const requestedQuantity = Number.parseInt(cartInput.value, 10);
        if (!Number.isFinite(requestedQuantity)) return;
        const quantity = Math.max(0, maximum === null
          ? requestedQuantity
          : Math.min(requestedQuantity, maximum));
        if (quantity !== requestedQuantity) {
          cartInput.value = String(quantity);
          if (maximum !== null && requestedQuantity > maximum) {
            setCartFeedback(stockLimitMessage(document.querySelector('[data-cart-section]'), maximum), true);
          }
        }
        const plusButton = line?.querySelector('[data-cart-plus]');
        if (plusButton) plusButton.disabled = maximum !== null && quantity >= maximum;
        return;
      }

      if (!event.target.matches('[data-shipping-postal]')) return;
      event.target.value = formatPostalCode(event.target.value);
      event.target.removeAttribute('aria-invalid');
    });

    document.addEventListener('submit', (event) => {
      const cartForm = event.target.closest('#InfoCartForm');
      if (cartForm && event.submitter?.name === 'checkout') {
        let invalidQuantity = false;
        cartForm.querySelectorAll('[data-cart-input]').forEach((input) => {
          const maximum = lineMaximum(input.closest('[data-cart-line]'));
          const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
          if (maximum !== null && quantity > maximum) {
            input.value = String(maximum);
            invalidQuantity = true;
          }
        });
        if (invalidQuantity) {
          event.preventDefault();
          const section = document.querySelector('[data-cart-section]');
          setCartFeedback(section?.dataset.cartStockErrorMessage || '', true);
        }
        return;
      }

      const shippingForm = event.target.closest('[data-shipping-form]');
      if (shippingForm) {
        event.preventDefault();
        calculateShipping(shippingForm.querySelector('[data-shipping-postal]').value);
        return;
      }

      const discountForm = event.target.closest('[data-discount-form]');
      if (!discountForm) return;
      event.preventDefault();
      const code = discountForm.querySelector('[data-discount-input]').value.trim();
      if (code) window.location.href = `${storefrontRoot()}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(storefrontRoot() + 'cart')}`;
    });

    restoreShippingEstimate();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-sort]').forEach((form) => {
    form.querySelector('[data-sort-select]')?.addEventListener('change', () => form.submit());
  });
  const formatPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  document.querySelectorAll('[data-price-display]').forEach((display) => {
    const value = document.getElementById(display.dataset.priceTarget);
    const syncPrice = () => {
      let raw = display.value.trim().replace(/[^0-9,.-]/g, '');
      if (raw.includes(',')) raw = raw.replace(/\./g, '').replace(',', '.');
      const amount = Number(raw);
      if (!raw || Number.isNaN(amount) || amount < 0) {
        value.value = '';
        display.value = '';
        return;
      }
      value.value = amount.toFixed(2);
      display.value = formatPrice.format(amount);
    };
    display.addEventListener('blur', syncPrice);
    display.closest('form')?.addEventListener('submit', syncPrice);
  });
  const filterPanel = document.querySelector('[data-filter-panel]');
  const filterOpen = document.querySelector('[data-filter-open]');
  const filterBackdrop = document.querySelector('[data-filter-backdrop]');
  const closeFilters = () => {
    filterPanel?.classList.remove('is-open');
    filterBackdrop?.classList.remove('is-visible');
    filterOpen?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('info-filters-open');
    filterOpen?.focus();
  };
  filterOpen?.addEventListener('click', () => {
    filterPanel?.classList.add('is-open');
    filterBackdrop?.classList.add('is-visible');
    filterOpen.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('info-filters-open');
    filterPanel?.focus();
  });
  document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilters));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && filterPanel?.classList.contains('is-open')) closeFilters();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const root = document.documentElement;
    if (root.dataset.infostoreCommerceReady === 'true') return;
    root.dataset.infostoreCommerceReady = 'true';
    const storageKey = 'infostore-wishlist-v1';
    const readItems = () => {
      try { return JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (error) { return []; }
    };
    const writeItems = (items) => localStorage.setItem(storageKey, JSON.stringify(items));
    const updateWishlist = () => {
      const items = readItems();
      document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
        count.textContent = items.length;
        count.hidden = items.length === 0;
      });
      document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
        const active = items.some((item) => String(item.id) === String(button.dataset.productId));
        button.setAttribute('aria-pressed', String(active));
        if (button.dataset.wishlistAddLabel && button.dataset.wishlistRemoveLabel) {
          button.setAttribute('aria-label', active ? button.dataset.wishlistRemoveLabel : button.dataset.wishlistAddLabel);
        }
      });
      const list = document.querySelector('[data-wishlist-items]');
      const empty = document.querySelector('[data-wishlist-empty]');
      if (!list || !empty) return;
      list.replaceChildren();
      empty.classList.toggle('is-visible', items.length === 0);
      items.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'info-wishlist-item';
        const image = document.createElement('img');
        image.src = item.image || '';
        image.alt = '';
        const content = document.createElement('div');
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        const price = document.createElement('strong');
        price.textContent = item.price;
        content.append(link, price);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'info-wishlist-item__remove';
        remove.dataset.wishlistRemove = item.id;
        remove.setAttribute('aria-label', `Remover ${item.title}`);
        const removeIcon = document.createElement('img');
        removeIcon.src = document.querySelector('[data-wishlist-close] img')?.src || '';
        removeIcon.alt = '';
        remove.append(removeIcon);
        row.append(image, content, remove);
        list.append(row);
      });
    };
    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        const items = readItems();
        const id = String(toggle.dataset.productId || '');
        const index = items.findIndex((item) => String(item.id) === id);
        if (index >= 0) items.splice(index, 1);
        else items.unshift({ id, title: toggle.dataset.productTitle, url: toggle.dataset.productUrl, price: toggle.dataset.productPrice, image: toggle.dataset.productImage });
        writeItems(items);
        updateWishlist();
      }
      const remove = event.target.closest('[data-wishlist-remove]');
      if (remove) {
        writeItems(readItems().filter((item) => String(item.id) !== String(remove.dataset.wishlistRemove)));
        updateWishlist();
      }
    });
    const wishlistDialog = document.querySelector('[data-wishlist-dialog]');
    document.querySelectorAll('[data-wishlist-open]').forEach((button) => button.addEventListener('click', () => { updateWishlist(); wishlistDialog?.showModal(); }));
    document.querySelector('[data-wishlist-close]')?.addEventListener('click', () => wishlistDialog?.close());
    window.addEventListener('storage', updateWishlist);
    updateWishlist();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["infostore-hero"] && !Shopify.designMode) return;
  try {
    
  const initInfoStoreCarousels = (scope) => {
    scope.querySelectorAll('[data-info-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready === 'true') return;
      carousel.dataset.ready = 'true';

      const slides = Array.from(carousel.querySelectorAll('[data-info-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
      const previous = carousel.querySelector('[data-carousel-previous]');
      const next = carousel.querySelector('[data-carousel-next]');
      const playback = carousel.querySelector('[data-carousel-playback]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = carousel.dataset.autoplay === 'true' && !reducedMotion && slides.length > 1;
      const interval = Number(carousel.dataset.interval) || 7000;
      let activeIndex = 0;
      let timer;
      let manuallyPaused = !autoplay;

      const syncVideos = () => {
        slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (index === activeIndex && !manuallyPaused && !document.hidden) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };

      const showSlide = (index, restart = true) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        syncVideos();
        if (restart && !manuallyPaused) startTimer();
      };

      const stopTimer = () => {
        if (timer) window.clearInterval(timer);
        timer = undefined;
      };

      const startTimer = () => {
        stopTimer();
        if (!manuallyPaused && !document.hidden) timer = window.setInterval(() => showSlide(activeIndex + 1, false), interval);
      };

      const setPaused = (paused) => {
        manuallyPaused = paused;
        playback?.classList.toggle('is-paused', paused);
        if (playback) playback.setAttribute('aria-label', paused ? playback.dataset.playLabel : playback.dataset.pauseLabel);
        if (paused) stopTimer(); else startTimer();
        syncVideos();
      };

      previous?.addEventListener('click', () => showSlide(activeIndex - 1));
      next?.addEventListener('click', () => showSlide(activeIndex + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.carouselDot))));
      playback?.addEventListener('click', () => setPaused(!manuallyPaused));
      carousel.addEventListener('mouseenter', stopTimer);
      carousel.addEventListener('mouseleave', () => { if (!manuallyPaused) startTimer(); });
      carousel.addEventListener('focusin', stopTimer);
      carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget) && !manuallyPaused) startTimer(); });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopTimer(); else if (!manuallyPaused) startTimer();
        syncVideos();
      });

      setPaused(!autoplay);
      showSlide(0, false);
    });
  };

  initInfoStoreCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initInfoStoreCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locacao-de-computadores"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRentalMotion = (root) => {
      if (root.dataset.rentalMotionReady === 'true') return;
      root.dataset.rentalMotionReady = 'true';
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;

      root.classList.add('is-rental-enhanced');
      const revealItems = root.querySelectorAll('[data-rental-reveal]');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-rental-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

      revealItems.forEach((item) => observer.observe(item));
    };

    document.querySelectorAll('[data-rental-section]').forEach(initRentalMotion);
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.matches('[data-rental-section]')
        ? event.target
        : event.target.querySelector('[data-rental-section]');
      if (root) initRentalMotion(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-section]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';

    const mainImage = section.querySelector('.info-product-gallery__main');
    section.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.imageUrl;
        mainImage.removeAttribute('srcset');
        mainImage.alt = button.dataset.imageAlt;
        section.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });

    section.querySelectorAll('[data-tab]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.tab;
        section.querySelectorAll('[data-tab]').forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        section.querySelectorAll('[data-panel]').forEach((panel) => {
          const active = panel.dataset.panel === target;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });

    const productForm = section.querySelector('.info-product-form');
    const quantity = section.querySelector('[data-quantity-control] input');
    const minusButton = section.querySelector('[data-quantity-minus]');
    const plusButton = section.querySelector('[data-quantity-plus]');
    const variantSelect = section.querySelector('[data-variant-select]');
    const variantNodes = () => variantSelect
      ? [...variantSelect.options]
      : [...section.querySelectorAll('[data-variant-state]')];
    const selectedVariantNode = () => variantSelect?.selectedOptions[0]
      || section.querySelector('[data-variant-state]');
    const numericData = (value, fallback = 0) => {
      const number = Number(value);
      return Number.isFinite(number) ? number : fallback;
    };
    const readVariantState = () => {
      const node = selectedVariantNode();
      if (!node) return null;
      const minimum = Math.max(1, numericData(node.dataset.quantityMin, 1));
      const increment = Math.max(1, numericData(node.dataset.quantityIncrement, 1));
      const cartQuantity = Math.max(0, numericData(node.dataset.cartQuantity, 0));
      const inventoryLimited = node.dataset.inventoryLimited === 'true';
      const inventoryQuantity = numericData(node.dataset.inventoryQuantity, 0);
      const ruleMaximum = node.dataset.quantityRuleMax === ''
        ? null
        : numericData(node.dataset.quantityRuleMax, null);
      const stockRemaining = inventoryLimited
        ? Math.max(0, inventoryQuantity - cartQuantity)
        : null;
      let maximum = ruleMaximum === null ? null : Math.max(0, ruleMaximum - cartQuantity);
      if (stockRemaining !== null && (maximum === null || stockRemaining < maximum)) maximum = stockRemaining;
      const available = node.dataset.available === 'true';
      const rejected = node.dataset.inventoryRejected === 'true';
      const canAdd = available && !rejected && (maximum === null || maximum >= minimum);
      return {
        node,
        variantId: numericData(node.value),
        minimum,
        increment,
        maximum,
        inventoryLimited,
        stockRemaining,
        available,
        rejected,
        canAdd
      };
    };
    const normalizedQuantity = (value, state) => {
      if (!state?.canAdd) return 0;
      const parsed = Number.parseInt(value, 10);
      let next = Number.isFinite(parsed) ? parsed : state.minimum;
      next = Math.max(state.minimum, next);
      next = state.minimum + Math.floor((next - state.minimum) / state.increment) * state.increment;
      if (state.maximum !== null) next = Math.min(next, state.maximum);
      return next;
    };
    const updatePurchaseState = ({ resetQuantity = false } = {}) => {
      const state = readVariantState();
      if (!state || !quantity) return;
      quantity.min = String(state.minimum);
      quantity.step = String(state.increment);
      if (state.maximum === null) quantity.removeAttribute('max');
      else quantity.max = String(state.maximum);
      quantity.disabled = !state.canAdd;
      quantity.value = String(state.canAdd
        ? normalizedQuantity(resetQuantity ? state.minimum : quantity.value, state)
        : 0);

      const currentQuantity = Number(quantity.value);
      if (minusButton) minusButton.disabled = !state.canAdd || currentQuantity <= state.minimum;
      if (plusButton) plusButton.disabled = !state.canAdd || (state.maximum !== null && currentQuantity >= state.maximum);
      section.querySelectorAll('[data-buy-button], [data-cart-button]').forEach((button) => {
        button.disabled = !state.canAdd;
        button.setAttribute('aria-disabled', String(!state.canAdd));
      });

      const stock = section.querySelector('[data-product-stock]');
      if (!stock) return;
      if (state.rejected) stock.textContent = section.dataset.stockChanged;
      else if (!state.available) stock.textContent = section.dataset.stockUnavailable;
      else if (!state.canAdd) stock.textContent = section.dataset.stockLimit;
      else if (state.inventoryLimited && state.stockRemaining === 1) stock.textContent = section.dataset.stockLastUnit;
      else if (state.inventoryLimited) stock.textContent = section.dataset.stockCount.replace('[count]', String(state.stockRemaining));
      else stock.textContent = section.dataset.stockAvailable;
      stock.classList.toggle('is-unavailable', !state.canAdd);
    };

    minusButton?.addEventListener('click', () => {
      const state = readVariantState();
      if (!state?.canAdd) return;
      quantity.value = String(normalizedQuantity(Number(quantity.value) - state.increment, state));
      updatePurchaseState();
    });
    plusButton?.addEventListener('click', () => {
      const state = readVariantState();
      if (!state?.canAdd) return;
      quantity.value = String(normalizedQuantity(Number(quantity.value) + state.increment, state));
      updatePurchaseState();
    });
    quantity?.addEventListener('input', () => {
      const state = readVariantState();
      if (!state?.canAdd || quantity.value === '') return;
      const requested = Number.parseInt(quantity.value, 10);
      if (state.maximum !== null && requested > state.maximum) quantity.value = String(state.maximum);
      if (requested < state.minimum) quantity.value = String(state.minimum);
      updatePurchaseState();
    });
    quantity?.addEventListener('change', () => updatePurchaseState());

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const compareWrap = section.querySelector('[data-product-compare-wrap]');
      section.querySelector('[data-product-price]').textContent = option.dataset.price;
      section.querySelector('[data-product-installments]').textContent = option.dataset.installments;
      if (option.dataset.compare) {
        compareWrap.hidden = false;
        section.querySelector('[data-product-compare]').textContent = option.dataset.compare;
        section.querySelector('[data-product-discount]').textContent = `${option.dataset.discount}% OFF`;
      } else {
        compareWrap.hidden = true;
      }
      updatePurchaseState({ resetQuantity: true });
    });

    productForm?.addEventListener('submit', (event) => {
      const state = readVariantState();
      if (!state?.canAdd) {
        event.preventDefault();
        updatePurchaseState();
        return;
      }
      quantity.value = String(normalizedQuantity(quantity.value, state));
    });

    document.addEventListener('shopify:cart:updated', (event) => {
      const cartItems = event.detail?.cart?.items || [];
      const rejectedVariantIds = event.detail?.rejectedVariantIds || [];
      variantNodes().forEach((node) => {
        const variantId = numericData(node.value);
        const cartQuantity = cartItems.reduce((total, item) => (
          Number(item.variant_id) === variantId ? total + Number(item.quantity || 0) : total
        ), 0);
        node.dataset.cartQuantity = String(cartQuantity);
        if (rejectedVariantIds.includes(variantId)) node.dataset.inventoryRejected = 'true';
      });
      updatePurchaseState();
    });

    updatePurchaseState();

    const shippingForm = section.querySelector('[data-shipping-form]');
    const postalCode = section.querySelector('[data-postal-code]');
    const shippingMessage = section.querySelector('[data-shipping-message]');
    postalCode?.addEventListener('input', () => {
      const digits = postalCode.value.replace(/\D/g, '').slice(0, 8);
      postalCode.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
    });
    shippingForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      const digits = postalCode.value.replace(/\D/g, '');
      shippingMessage.textContent = digits.length === 8
        ? section.dataset.shippingResult
        : section.dataset.shippingError;
    });

    const shareButton = section.querySelector('[data-share-product]');
    const shareStatus = section.querySelector('[data-share-status]');
    shareButton?.addEventListener('click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: window.location.href });
          return;
        }
        await navigator.clipboard.writeText(window.location.href);
        shareStatus.textContent = section.dataset.shareSuccess;
      } catch (error) {
        if (error.name !== 'AbortError') throw error;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
